<template>
  <v-container class="fill-height">
    <v-row class="fill-height">
      <v-col sm="12" class="d-flex align-center justify-center">
        <v-card class="text-center pa-4 ma-4" v-if="!overlay">
          <p class="mt-4">Please sign the invoice to proceed with the service</p>
          <v-btn class="mb-5" @click="signDocument()" dark>SIGN INVOICE</v-btn>
        </v-card>
        <v-card class="text-center px-12" max-width="540" v-else>
          <v-row class="loadingText">
            <LoaderDoc/>
          </v-row>
          <v-row class="pb-8">
            <h1>You are being redirected to zoho sign. Please do not close or leave this page.</h1>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import createDocumentUrl from '@/helpers/createDocumentUrl'
import LoaderDoc from '@/components/Loader.vue'

  export default {
    components: {LoaderDoc},
    data: () => ({
      overlay: false
    }),
    computed:{
      ...mapState(['dealId'])
    },
    methods:{
      async signDocument(){
        this.overlay = true
        const createUrl = await createDocumentUrl(this.dealId)
        const url = createUrl.url
        window.location.href = url;
        setTimeout(() => {
          this.overlay = false
        }, 1000);
      }
    }
  }
</script>

<style scope>
.loadingText{
  padding-bottom: 100px;
}
.v-divider{
  background: #D0CDC9;
}
.v-card{
  border-radius: 30px !important;
  max-width: 50rm;
}
.btn {

  margin-top: 20px;
  font-size: 16px;
  max-height: 25px;
}
.content-permissions {
  background: linear-gradient(180deg, rgba(254,254,254,1) 0%, rgb(211, 212, 212) 99%);
  border-radius: 30px !important;
}
p {
  font-size: 20px;
}
h1{
  font-size: 18px;
}
</style>
